import React from 'react';
import { MegaHeader } from './MegaHeader';
import { StyleProp, MantineColor, AppShell, Container, useMantineColorScheme, Stack, ScrollArea } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

interface LayoutProps {
    children: React.ReactNode;
    bg?: StyleProp<MantineColor>
    location?: any
}

export function Layout({ children, location }: LayoutProps) {
    const [opened, { toggle }] = useDisclosure();
    const { colorScheme } = useMantineColorScheme()
    const searchParams = new URLSearchParams(location?.search);
    const hideHeader = searchParams.get('hideHeader') === 'true';

    if (hideHeader) return <>{children}</>

    return (
        <AppShell
            header={{
                height: 50,
                //collapsed: !pinned, 
                offset: true
            }}
        >
            <AppShell.Header>
                <MegaHeader opened={opened} toggle={toggle} />
            </AppShell.Header>

            <AppShell.Main pb={15} w={'100%'} bg={colorScheme === 'dark' ? '' : '#f3f3f3'}>
                <Container pt={15} size={'xl'}>
                    {children}
                </Container>
            </AppShell.Main>
        </AppShell>

    );
}

